(function() {
    'use strict';
    angular.module('voyageReport').controller('VoyageReportCtrl', VoyageReportCtrl);

    function VoyageReportCtrl($sce) {
        var vm = this;
    }
}());